export default "__VITE_ASSET__c67d96e6__"